import { setMetadata, getMetadata, Metadata } from '@creditornot/browser-telemetry';

import { ResourceType } from './types';

const updateMetadata = (newMetadata: Metadata) => {
  setMetadata({
    ...getMetadata(),
    ...newMetadata,
  });
};

export const resetMetadataResource = () => {
  const currentMetadata: Metadata | undefined = getMetadata() || {};
  const { venue_id, merchant_id, brand_id, enterprise_id, ...rest } = currentMetadata;
  setMetadata(rest);
};

export const setMetadataResource = (resourceId: string, resourceType: ResourceType) => {
  const resourceTypeForTelemetry: string = `${resourceType}_id`;
  resetMetadataResource();
  updateMetadata({ [resourceTypeForTelemetry]: resourceId });
};
